// Polis, the Electorate tab in the new interface (10 October 2026).
export default {
  chargement: 'Reading the electorate…',
  erreur: 'The electorate could not be read.',
  fermer: 'Close',
  reessayer: 'Try again',
  projetee: {
    titre: 'Projected turnout',
    legende: 'each wave projects it, the latest first',
    fourchette: '{bas} ~ {haut}',
    exprimes: '{n} million valid votes out of {inscrits} million registered voters',
    aria: '{jour}: {taux}, between {bas} and {haut}',
  },
  bref: {
    aria: 'The electorate at a glance',
    participationSecteurs: 'expected turnout, sector by sector',
    participationEnsemble: 'expected turnout across the whole electorate',
    ecart: '{bas} ~ {haut}',
    ecartPhrase: 'the turnout gap between {moins} and {plus}',
    moinsOptimiste: 'of {nom} believe the country is heading in the right direction, the lowest',
  },
  secteurs: {
    titre: 'Sectors',
    ordre: 'largest to smallest',
    secteur: 'Sector',
    part: 'Share of the electorate',
    participation: 'Turnout',
    vote: 'Vote at the previous election',
    optimistes: 'Optimistic about the country',
    voteAria: 'Vote at the previous election: {detail}',
  },
  choisi: {
    surtitre: 'Sector',
    // The election's Sonar (11 October 2026).
    interroger: 'Talk to this sector',
    part: '{part} of the electorate',
    participation: 'expected turnout {pct}',
    vote: 'Their vote at the previous election',
    pays: 'believe the country is heading in the right direction',
    soi: 'say things are going well for them',
    mouvementSr: 'points since the baseline',
    noteSansMouvement: 'State of mind measured every Saturday among the same twins; no movement since the baseline.',
    noteAvecMouvement: 'State of mind measured every Saturday among the same twins; next to each figure, its movement since the baseline.',
  },
  seul: {
    titre: 'The electorate reads as a single whole',
    participation: 'expected turnout',
    sansParticipation: 'No expected turnout yet.',
  },
}
